<template>
	<layout-page title="cropspot+">
		<!-- title -->
		<div
			class="bg-green px-4 sm:px-6 py-4 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
		>
			<h1 class="text-2xl md:text-4xl font-semibold text-white">
				cropspot+
			</h1>
		</div>

		<div class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100">
			<p class="py-2 text-2xl font-semibold">cropspot ist Ihr Experte für den Handel mit Agrarrohstoffen!</p>

			<p class="my-4 text-lg">
					cropspot+ liefert Ihnen mehr Hintergründe, mehr aufbereitete Daten, mehr Übersicht, mehr meinungsstarke Orientierung - einfach mehr Wissen. Immer bestens informiert.
			</p>

			<!-- Panel My cropspot+ -->
			<div v-if="premium"
					 class="my-6 py-5">
				<div
					class="bg-gray-700 px-4 py-4 sm:px-6 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center shadow"
				>
					<h3 class="text-2xl md:text-4xl font-semibold text-white">
						Mein cropspot+
					</h3>

				</div>

				<div class="bg-white p-5 lg:rounded-b-2xl xl:rounded-b-2xl shadow text-gray-900">
					<div class="flex justify-between flex-col-reverse md:flex-row px-4">
						<div class="basis-0 flex-grow md:max-w-[50%] my-4">
							<p class="font-semibold text-2xl">Abonnement-Details</p>

							<div v-if="premium.payment_status === 'UNAUTHORIZED'"
								class="flex flex-column items-center my-3 gap-x-3 text-red-600 font-medium">

								<ui-icon name="alert-triangle" stroke-width="1.5" class="flex-shrink-0 h-10 mt-1" />
								<p>
									<span class="block">Fügen Sie eine Zahlungsmethode hinzu, um Ihre Buchung abzuschließen. Oder wenden Sie sich an den Support unter <a href="mailto:info@cropspot.com">info@cropspot.com</a>.</span>
								</p>
							</div>

							<div v-else-if="['FAILED', 'CHARGED_BACK'].includes(premium.payment_status)"
								class="flex flex-column items-center my-3 gap-x-3 text-red-600 font-medium">

								<ui-icon name="alert-triangle" stroke-width="1.5" class="flex-shrink-0 h-10 mt-1" />
								<p>
									<span class="block">Ihr Abonnement ist ausgesetzt. Bitte wenden Sie sich an den Support unter <a href="mailto:info@cropspot.com">info@cropspot.com</a>.</span>
								</p>
							</div>


							<ul>
								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between font-medium">
										<span>Laufzeit</span>
										<span>
											Aktiv bis <span class="font-bold">{{ formatDate(premium.valid_until) }}</span>
										</span>
									</div>
									<div class="text-right text-xs">
										<span>(Kündigungsfrist: {{ noticePeriodDays }} Tage vor Ende der Abolaufzeit)</span>
									</div>
								</li>
								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between items-center">
										<span class="font-medium">Zahlungsmethode</span>
										<span class="flex items-center">
											<span class="font-bold">{{ __(premium.payment_method_label) }}</span>
<!--											<img class="h-5 mr-2" :src="premium.payment_method_image" />-->

											<ui-tooltip class="font-normal" :text="premium.payment_method_code ? __('Edit payment method') : __('Add payment method')">
												<template v-slot:label>
													<button
														:disabled="!canEditPaymentMethod"
														class="hover:bg-gray-100 rounded-lg p-2"
														:class="[
																canEditPaymentMethod ? 'text-orange-500' : 'text-gray-300',
															]"
														v-on:click="
															$bus.$emit('modal:open', {
																	dataUrl: $route('premium.resolvePaymentMethodUpdateDependencies'),
																	steps: [
																		{
																			key: 'payment',
																			view: 'views/Premium/PaymentMethodEdit',
																		},
																		{
																			key: 'checkout',
																			view: 'views/Premium/PaymentMethodCheckout',
																		},
																	],
															})
														"
													>
														<ui-icon class="h-5 w-5" name="edit" stroke-width="2.5" />
													</button>
												</template>
											</ui-tooltip>

										</span>

									</div>
									<div class="text-right" v-if="sepaMandate">
										<span class="block">{{ sepaMandate.consumerName }}</span>
										<span class="block">{{ sepaMandate.consumerAccount }}</span>
									</div>
								</li>
								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between">
										<span class="font-medium">
											<span class="block">Kontingent</span>
											<span class="block">Freihandelsmenge</span>
										</span>

										<span v-if="premium.free_qty__mt_left > 0">
											<span class="font-bold">{{ premium.free_qty__mt_left }} Tonnen</span>
											<span class="font-medium">übrig</span>
										</span>
										<span v-else>
											<span class="font-medium">verbraucht</span>
										</span>
									</div>
									<span class="block my-3 text-xs text-right">Das Kontingent wird jeweils zum Beginn eines neuen Abrechnungszeitraums zurückgesetzt.</span>
								</li>

								<li class="text-center" v-if="! premium.terminated_at">

									<div class="flex flex-column items-center my-3 gap-x-3 font-medium" v-if="premium.status === 'TRIAL'">
										<ui-icon v-if="showTrialWarning" name="alert-triangle" stroke-width="1.5" class="flex-shrink-0 h-10 mt-1 text-red-600" />
										<p :class="[showTrialWarning ? 'text-red-600' : 'text-sm']">
											Ihr {{ trialDays }}-tägiger Testzeitraum läuft am {{ formatDate(premium.trial_until) }} ab.
										</p>
									</div>

									<ui-button
										class="block w-full my-5 px-6 py-3"
										label="Kündigung"
										type="primary-reverted"
										v-on:click="
													$bus.$emit('modal:open', {
														view: {
															// dataUrl: $route('premium.resolveBookingDependencies'),
															view: 'views/Premium/Termination',
															data: { id: premium.id },
														}
													})
												"
									/>
								</li>
								<li v-else-if="premium.terminated_at">
									<div class="flex flex-column items-center my-3 gap-x-3 text-red-600 font-medium">

										<ui-icon name="alert-triangle" stroke-width="1.5" class="flex-shrink-0 h-10 mt-1" />
										<div v-if="premium.payment_status === 'UNAUTHORIZED' && !premium.payment_method_code">
											<p>
												Sie haben Ihr cropspot+ Abo gekündigt. Ihnen enstehen keine Kosten.
											</p>
										</div>
										<div v-else-if="premium.status === 'TRIAL'">
											<p>
												Sie haben Ihr cropspot+ Abo innerhalb des kostenlosen Testzeitraums gekündigt. Ihr Zugriff endet am {{ formatDate(premium.valid_until) }}.
											</p>
											<p>
												Sie wollen cropspot+ doch noch weiter nutzen? Reaktivieren Sie Ihr Abo, um weiterhin von allen Inhalten und Funktionen zu profitieren.
											</p>
										</div>
										<div v-else>
											<p>
												Sie haben Ihr cropspot+ Abo gekündigt und Ihr Zugriff endet am {{ formatDate(premium.valid_until) }}.
											</p>
											<p>
												Sie wollen cropspot doch noch weiter nutzen? Reaktivieren Sie Ihr Abo, um weiterhin von allen Inhalten und Funktionen zu profitieren.
											</p>
										</div>
									</div>

									<ui-button
										:disabled="premium.payment_status === 'UNAUTHORIZED'"
										class="block w-full my-5 px-6 py-3"
										label="Abo fortsetzen"
										v-on:click="
										$bus.$emit('modal:open', {
											view: {
												view: 'views/Premium/TerminationRevoke',
												data: { id: premium.id },
											}
										})
									"
									/>
								</li>
							</ul>
						</div>

						<div class="basis-0 flex-grow relative md:max-w-[50%] flex justify-center px-3 py-3 items-center">
							<div class="basis-4/5 max-w-[80%] text-center">
								<img class="my-3 inline-block" src="/images/premium-laptop.png" />
								<img class="absolute left-1/2 top-1/2 -translate-x-[200%] md:-translate-x-[250%] -translate-y-[15%] -rotate-[15deg] max-w-[20%] md:max-w-[15%]" src="/images/premium-smartphone.png"/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Panel Test -->
			<div class="my-6 py-5" v-else-if="trialAvailable">
				<div
					class="bg-gray-700 px-6 py-4 sm:px-6 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center shadow"
				>
					<h3 class="text-2xl md:text-4xl font-semibold text-white">
						Jetzt {{ trialDays }} Tage kostenlos ausprobieren!
					</h3>

				</div>

				<div class="bg-white p-6 lg:rounded-b-2xl xl:rounded-b-2xl shadow">
					<div class="flex justify-between flex-col-reverse md:flex-row px-4">
						<div class="basis-0 flex-grow md:max-w-[60%] my-4">
							<p>Starten Sie jetzt Ihren {{ trialDays }}-tägigen, kostenlosen Testzeitraum und erleben alle Vorteile unseres cropspot+ Abos.</p>
							<p class="mt-2">Während der Testphase erhalten Sie uneingeschränkten Zugriff auf alle Funktionen, exklusiven Inhalte und Premium-Services.</p>

							<p class="my-5 font-semibold">So funktioniert’s:</p>
							<ol class="list-decimal px-4">
								<li class="py-1">Schließen Sie mit nur wenigen Klicks ein cropspot+ Jahresabo ab.</li>
								<li class="py-1">Genießen Sie die ersten {{ trialDays }} Tage lang alle Vorteile von cropspot+.</li>
								<li class="py-1">Gefällt Ihnen unser Angebot? Dann läuft Ihr Test automatisch in das kostenpflichtige Jahresabo über – ganz ohne Unterbrechung.
									Der Preis für das cropspot+ Jahresabo beträgt {{ price }} € inkl. MwSt. und wird erst mit Ende der Testphase fällig.</li>
								<li class="py-1">Sie möchten nicht verlängern? Kein Problem – kündigen Sie einfach vor Ablauf des {{ trialDays }}-tägigen Testzeitraums, und es entstehen Ihnen keine Kosten.</li>
							</ol>
						</div>

						<div class="basis-0 flex-grow relative md:max-w-[50%] flex justify-center px-3 py-3 items-center">
							<div class="basis-4/5 max-w-[80%] text-center">
								<img class="my-3 inline-block" src="/images/premium-laptop.png" />
								<img class="absolute left-1/2 top-1/2 -translate-x-[200%] md:-translate-x-[250%] -translate-y-[15%] -rotate-[15deg] max-w-[20%] md:max-w-[15%]" src="/images/premium-smartphone.png"/>
							</div>
						</div>
					</div>


					<div class="text-center">
						<ui-button
							:disabled="!canSubscribe"
							class="my-5 px-6 py-3"
							label="Jetzt kostenlos testen!"
							v-on:click="
									$bus.$emit('modal:open', {
											wizard: true,
											dataUrl: $route('premium.resolveBookingDependencies'),
											steps: [
												{
													key: 'payment',
													view: 'views/Premium/Booking',
													dataUrl: $route('premium.resolveBookingDependencies'), // todo step wird ohne url nicht übergeben
												},
												{
													key: 'checkout',
													view: 'views/Premium/Checkout',
													dataUrl: $route('premium.resolveBookingDependencies'), // todo step wird ohne url nicht übergeben
												}
											]
									})
								"
						/>
					</div>
				</div>
			</div>

			<!-- Panel Booking -->
			<div v-else-if="!premium" class="my-6 py-5">
				<div
					class="bg-gray-700 px-4 py-4 sm:px-6 lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center shadow"
				>
					<h3 class="text-2xl md:text-4xl font-semibold text-white">
						Jetzt cropspot+ Abo abschließen!
					</h3>
				</div>

				<div class="bg-white p-5 lg:rounded-b-2xl xl:rounded-b-2xl shadow">
					<div class="flex justify-between flex-col-reverse md:flex-row px-4">
						<div class="basis-0 flex-grow md:max-w-[50%] my-4">
							<p class="font-semibold">Den Markt im Blick. Die Vermarktung im Griff.</p>
							<p>Aktuelle Preise, verständliche Marktinfos und klare Analysen helfen Ihnen, bessere Entscheidungen zu treffen!</p>

							<p class="font-semibold mt-4">So funktioniert’s:</p>

							<ul>

								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between">
										<span class="font-semibold">Preis</span>
										<span class="font-bold">{{ price }} {{ __(currency)}}/Jahr</span>
									</div>
									<div class="text-right">
										<span>inkl. der gesetzlichen MwSt.</span>
									</div>
								</li>
								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between">
										<span class="font-semibold">Laufzeit</span>
										<span class="font-bold">1 Jahr</span>
									</div>
									<div class="text-right text-xs">
										<span>(Kündigungsfrist: {{ noticePeriodDays}} Tage vor Ablauf der Abolaufzeit)</span>
									</div>
								</li>
								<li class="py-2 border border-solid border-gray-400 border-bottom border-t-0 border-l-0 border-r-0">
									<div class="flex justify-between">
										<span class="font-semibold">Freihandelsmenge</span>
										<span class="font-bold">{{ qtyIncluded }} Tonnen / Laufzeitjahr</span>
									</div>
								</li>

							</ul>

							<div class="text-center justify-center flex mt-6">
								<div class="flex items-left items-center">
									<font-awesome-icon
										icon="fa-light fa-lightbulb-exclamation-on"
										class="text-5xl mr-6"
									/>
									<p class="text-left">
										Mit Ihrem Freihandels&shy;kontingent können Sie die Kosten für Ihr cropspot+ Abo wieder ausgleichen. Nutzen Sie Ihr Freihandels&shy;kontingent aktiv und holen Sie das Maximum aus cropspot+ heraus!
									</p>
								</div>
							</div>

						</div>

						<div class="basis-0 flex-grow relative md:max-w-[50%] flex justify-center px-3 py-3 items-center">
							<div class="basis-4/5 max-w-[80%] text-center">
								<img class="my-3 inline-block" src="/images/premium-laptop.png" />
								<img class="absolute left-1/2 top-1/2 -translate-x-[200%] md:-translate-x-[250%] -translate-y-[15%] -rotate-[15deg] max-w-[20%] md:max-w-[15%]" src="/images/premium-smartphone.png"/>
<!--								max-w-[15%] -->
							</div>
						</div>

					</div>

					<div class="text-center">
						<ui-button
							class="my-5 px-6 py-3"
							label="Jetzt abschließen!"
							:disabled="!canSubscribe"
							v-on:click="
									$bus.$emit('modal:open', {
											dataUrl: $route('premium.resolveBookingDependencies'),
											steps: [
												{
													key: 'payment',
													view: 'views/Premium/Booking',
													dataUrl: $route('premium.resolveBookingDependencies') // todo step wird ohne url nicht übergeben
												},
												{
													key: 'checkout',
													view: 'views/Premium/Checkout',
													dataUrl: $route('premium.resolveBookingDependencies') // todo step wird ohne url nicht übergeben
												}
											]
									})
								"
						/>
					</div>
				</div>
			</div>

			<!-- Panel Advantages -->
			<div class="bg-white my-5 lg:rounded-2xl my-6 py-6 shadow text-gray-900">
					<h3 class="flex items-center justify-center text-2xl md:text-4xl my-3 font-bold">
						Vorteile mit
						<img class="mt-1 mx-2" src="/images/Logo_cropspot_PLUS.svg">
					</h3>

				<div class="flex justify-center p-5 px-6">
					<table class="w-full max-w-[80%] px-4 text-gray-900">
						<tr>
							<th class="py-3 text-left font-bold text-lg leading-5">Vorteile</th>
							<th class="py-3 font-bold text-lg">Ohne cropspot+</th>
							<th class="py-3 font-bold text-lg">Mit cropspot+</th>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Ware inserieren und verhandeln</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Teilnahme an wöchentlichen Auktionen</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">150 Tonnen ohne Kommission verkaufen</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Zugriff auf den wöchentlichen cropspot Marktkompass</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Preisticker mit freibleibenden Frei-Fuhre-Preise für Ihren Standort</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Zugriff auf Planung und Übersicht zu Ihrem Vermarktungsstatus</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Zugriff auf Vermarktungsdashboard ‘Meine Kontrakte’</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
						<!-- Entry -->
						<tr class="border border-solid border-gray-400 border-b-5 border-b-0 border-x-0">
							<td class="py-4">Hinzufügen von externen Kontrakten</td>
							<td class="text-center">
								x
							</td>
							<td class="text-center">
								<font-awesome-icon
									icon="fas fa-check-circle"
									class="text-xl text-green"
								/>
							</td>
						</tr>
					</table>
				</div>
			</div>

		</div>
	</layout-page>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import {formatDate, formatLocalizedNumber} from "../../cropOptions";

export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		trialDays: {
			type: String,
		},
		netPrice: {
			type: Number,
		},
		tax: {
			type: Number,
		},
		currency: {
			type: String,
		},
		noticePeriodDays: {
			type: Number,
		},
		qtyIncluded: {
			type: Number,
		},
	},
	data() {
		return {
			premium: this.$page.props.premium ?? null,
			sepaMandate: this.$page.props.sepaMandate,
			paymentMethod: this.$page.props.paymentMethod ?? null,
			acl: this.$inertia.page.props.acl,
		}
	},
	mounted(){
		this.$bus.$on("content:load", this.loadContent);
	},
	beforeDestroy() {
		this.$bus.$off("content:load", this.loadContent);
	},
	computed: {
		price: function() {
			return formatLocalizedNumber(this.netPrice * (1 + this.tax));
		},
		trialAvailable() {
			return this.acl.subscriptions_trial ?? false
		},
		canSubscribe() {
			return this.acl['subscriptions.subscribe'];
		},
		canEditPaymentMethod() {
			return this.acl['subscriptions.payment_method'];
		},
		showTrialWarning() {
			const date = this.addDays(new Date(), 7);
			const trialUntilDate = new Date(this.premium.trial_until);

			return date > trialUntilDate;
		}
	},
	methods: {
		formatDate,
		addDays(date, days) {
				const result = new Date(date);
				result.setDate(result.getDate() + days);
				return result;
			},
		loadContent() {
			const params = {};
			if (this.user) {
				params["user_id"] = this.user.id;
			}

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(this.$route('premium.content', params));

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.premium = result.data.premium;
			this.paymentMethod = result.data.paymentMethod;
			this.sepaMandate = result.data.sepaMandate;
		},
		onError(error) {
			// todo
		},
	},
};
</script>
